export default __webpack_public_path__ + "static/media/hht2_ep13_timeline_q03_b.e4eb72c0.png";